<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <!-- <custom-popup
          v-model="priceDial"
          :cons="{ title: $t('group_qr_renewal') }"
          hide-confirm
          max-width="500"
          transition="dialog-bottom-transition"
          @close="() => (time = 0)"
        >
          <v-card class="pb-6" flat>
            <v-card-title>{{ $t('select_desired_duration') }}</v-card-title>

            <v-card-actions class="d-flex justify-content-around p-12 pb-2">
              <div
                v-for="(item, i) in renewalItems"
                :key="i"
                class="rowinfo"
                style="width: 100% !important"
              >
                <v-btn
                  :color="item.value === time ? 'orange' : 'warning'"
                  :loading="loading"
                  class="text-dark font-weight-bold contentinfo"
                  @click="getPrice(item.value)"
                >
                  <v-icon left>mdi-clock</v-icon>
                  {{ item.text }}
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-${item.text}`"
                  :help-data="helpData"
                  :service-name="serviceName"
                  class="buttoninfo"
                  :label="`${item.text}`"
                />
              </div>
            </v-card-actions>
          </v-card>

          <v-card
            v-if="massUpdatePriceData?.total_count && !!time"
            :loading="loading"
            class="p-8"
            flat
          >
            <hr />

            <h3>
              {{ $t('total_count') }}:
              <span>{{ massUpdatePriceData?.total_count }}</span
              ><v-btn @click="showDetails = !showDetails" disabled
                ><v-icon>{{
                  !showDetails
                    ? "mdi-chevron-double-down"
                    : "mdi-chevron-double-up"
                }}</v-icon
                >{{ $t('details') }}</v-btn
              >
              <v-col
                v-if="
                  !!paginationgroup &&
                  paginationgroup?.data?.length > 0 &&
                  showDetails
                "
                style="width: 100%"
                class="pa-4"
              >
                <vue-table
                  v-model="selectedRowsgroup"
                  :data="selectedItemsDetails"
                  :headers="headersdetail"
                  :per-page.sync="computedPerPagedetail"
                  item-key="type"
                >
                  <template v-slot:index="{ item, index }">
                    {{ index + 1 }}
                  </template>
                  <template v-slot:type="{ item }">
                    <template v-if="getQrTypes(item.type)">
                      <v-icon>mdi-{{ getQrTypes(item.type).icon }}</v-icon>
                      {{ getQrTypes(item.type).name }}
                    </template>
                  </template>
                  <template v-slot:count="{ item }">
                    {{ item.count }}
                  </template>
                </vue-table>
              </v-col>
            </h3>

            <h3>
              {{ $t('final_amount') }}:
              <span>{{ massUpdatePriceData?.sum_price.toLocaleString() }}</span>
              ﷼
            </h3>

            <v-alert border="left" color="red" dark dense>
              {{ $t('ten_percent_vat_will_be_added') }}
            </v-alert>

            <div class="d-flex justify-content-center mt-3">
              <div class="rowinfo" style="width: 100%">
                <v-btn
                  :loading="loading"
                  class="font-weight-bold px-12"
                  color="success"
                  @click="massUpdate(time)"
                >
                  {{ $t('pay_and_upgrade') }}
                </v-btn>
              </div>
              <help-info
                :element-name="`${serviceName}-${componentName}-pay-update`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('pay_and_upgrade')"
              />
            </div>
          </v-card>

          <v-card
            v-if="!massUpdatePriceData?.total_count && !!time && !loading"
          >
            <v-card-title class="text-center justify-center">
              <v-icon color="black">mdi-currency-usd</v-icon>
              {{ $t('no_tariff_for_this_period') }}
            </v-card-title>
          </v-card>
        </custom-popup> -->
        <custom-popup
          v-model="priceDial"
          :cons="{
            title: $t('group_qr_renewal'),
            icon: 'timer-refresh-outline',
          }"
          hide-confirm
          max-width="850"
          transition="dialog-bottom-transition"
          :loading="popupLoading"
          @close="() => (time = 0)"
        >
          <v-card-title class="pt-4">{{
            $t("select_desired_duration")
          }}</v-card-title>
          <v-container class="pa-8 pt-4">
            <v-row v-if="!time">
              <v-col
                v-for="(item, i) in renewalItems"
                :key="i"
                cols="12"
                md="6"
                class="pa-4"
              >
                <v-card
                  :loading="cardloading && item.value === time"
                  elevation="2"
                  rounded="lg"
                  class="pa-3 vtest"
                  style="
                    border-top: 6px solid orange;
                    border-bottom: 6px solid orange;
                  "
                >
                  <!-- Clickable Orange Box -->
                  <div class="text-center mb-4">
                    <v-chip
                      color="orange"
                      text-color="white"
                      class="font-weight-bold text-h6"
                      @click="getPrice(item.value)"
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon left>mdi-clock</v-icon>
                        {{ item.text }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${item.text}`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          :label="`${item.text}`"
                        />
                      </div>
                    </v-chip>
                  </div>
                  <v-divider class="my-4" />
                </v-card>
              </v-col>
            </v-row>

            <v-row v-else>
              <v-col cols="12" md="6" class="pa-2">
                <v-row>
                  <v-col
                    v-for="(item, i) in renewalItems"
                    :key="i"
                    cols="12"
                    class="pa-2"
                  >
                    <v-card
                      :loading="cardloading && item.value === time"
                      elevation="2"
                      rounded="lg"
                      class="pa-2"
                      :style="{
                        borderTop:
                          item.value === time
                            ? '6px solid #BF360C'
                            : '6px solid orange',
                        borderBottom:
                          item.value === time
                            ? '6px solid #BF360C'
                            : '6px solid orange',
                      }"
                    >
                      <div class="text-center mb-1">
                        <v-chip
                          :color="item.value === time ? '#BF360C' : 'orange'"
                          text-color="white"
                          class="font-weight-bold text-h6"
                          @click="
                            item.value === time
                              ? (time = 0)
                              : getPrice(item.value)
                          "
                          :loading="priceloading && item.value === time"
                          ><div
                            style="
                              display: flex;
                              justify-content: center;
                              align-items: center;
                            "
                          >
                            <v-icon left>mdi-clock</v-icon>
                            {{ item.text }}
                            {{ item.value === time ? $t("selected") : "" }}
                            <help-info
                              :element-name="`${serviceName}-${componentName}-${item.text}`"
                              :help-data="helpData"
                              :service-name="serviceName"
                              class="buttoninfo"
                              :label="`${item.text}`"
                            />
                          </div>
                        </v-chip>
                      </div>
                      <v-divider class="my-2" />
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12" md="6" class="pa-2">
                <v-card
                  :loading="cardloading && time === selectedTime"
                  elevation="5"
                  rounded="lg"
                  class="pa-4"
                  style="
                    border-top: 8px solid #ca3102ff;
                    border-bottom: 8px solid #ca3102ff;
                  "
                >
                  <div class="text-center mb-4">
                    <v-chip
                      color="#ca3102ff"
                      text-color="white"
                      class="font-weight-bold text-h6"
                      @click="time = 0"
                    >
                      <div
                        style="
                          display: flex;
                          justify-content: center;
                          align-items: center;
                        "
                      >
                        <v-icon left>mdi-clock</v-icon>
                        {{ $t("view") }}
                        {{ renewalItems.find((it) => it.value === time).text }}
                        <help-info
                          :element-name="`${serviceName}-${componentName}-${
                            renewalItems.find((it) => it.value === time).text
                          }`"
                          :help-data="helpData"
                          :service-name="serviceName"
                          class="buttoninfo"
                          :label="`${
                            renewalItems.find((it) => it.value === time).text
                          }`"
                        />
                      </div>
                    </v-chip>
                  </div>
                  <v-divider class="my-4" />

                  <v-expand-transition>
                    <div v-if="massUpdatePriceData?.total_count">
                      <v-row class="ma-0" align="center">
                        <v-col cols="12" class="text-h6">
                          {{ $t("total_count") }}:
                          <span v-if="!priceloading" class="font-weight-bold">{{
                            persian(massUpdatePriceData?.total_count)
                          }}</span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          <v-btn
                            text
                            color="primary"
                            @click="showDetails = !showDetails"
                            class="mr-2"
                          >
                            <v-icon>
                              {{
                                showDetails
                                  ? "mdi-chevron-double-up"
                                  : "mdi-chevron-double-down"
                              }}
                            </v-icon>
                            {{ $t("details") }}
                          </v-btn>
                        </v-col>
                        <v-col v-if="showDetails" cols="12" class="pa-2">
                          <v-sheet class="slider-wrapper" elevation="6">
                            <v-slide-group
                              v-model="model"
                              class="mt-2"
                              show-arrows
                              center-active
                            >
                              <v-slide-item
                                elevation="6"
                                v-for="(item, index) in qrTypeCounts"
                                :key="index"
                              >
                                <v-card
                                  elevation="4"
                                  rounded="lg"
                                  class="pa-2 text-center ma-1"
                                  style="
                                    position: relative;
                                    border-radius: 10px;
                                    max-width: 200px;
                                    margin: 0 auto;
                                  "
                                >
                                  <v-badge
                                    :content="item.value"
                                    color="warning"
                                    offset-x="10"
                                    offset-y="10"
                                  >
                                    <v-icon large color="#ca3102ff">
                                      mdi-{{
                                        getQrTypes(item.key)?.icon || "qrcode"
                                      }}
                                    </v-icon>
                                  </v-badge>
                                  <div
                                    class="mt-1 text-subtitle-1 font-weight-medium"
                                  >
                                    {{ getQrTypes(item.key)?.name || item.key }}
                                  </div>
                                </v-card>
                              </v-slide-item>
                            </v-slide-group>
                          </v-sheet>
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("total_amount") }}:
                          <span
                            v-if="!priceloading"
                            class="font-weight-bold text-decoration-line-through"
                            >{{
                              persian(
                                (
                                  massUpdatePriceData?.sum_price *
                                  (1 +
                                    massUpdatePriceData?.discountPriceByCount *
                                      0.001)
                                ).toLocaleString()
                              )
                            }}</span
                          >
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("discount") }}:
                          <span
                            v-if="!priceloading"
                            class="font-weight-bold"
                            style="color:red;s"
                            >{{
                              persian(
                                (
                                  massUpdatePriceData?.sum_price *
                                  massUpdatePriceData?.discountPriceByCount *
                                  0.001
                                ).toLocaleString()
                              )
                            }}</span
                          >
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-row class="ma-0">
                        <v-col cols="12" class="text-h6">
                          {{ $t("final_amount_with_discount") }}:
                          <span v-if="!priceloading" class="font-weight-bold">{{
                            persian(
                              massUpdatePriceData?.sum_price.toLocaleString()
                            )
                          }}</span>
                          <v-progress-circular
                            v-else
                            indeterminate
                            color="orange"
                            size="24"
                            class="ma-2"
                          ></v-progress-circular>
                          ﷼
                        </v-col>
                      </v-row>
                      <v-alert type="info" dense text class="ma-4">
                        {{ $t("ten_percent_vat_will_be_added") }}
                      </v-alert>

                      <v-row class="ma-0" justify="center">
                        <v-col cols="auto">
                          <v-btn
                            :loading="paymentloading"
                            color="success"
                            class="font-weight-bold px-8"
                            large
                            @click="handleMassUpdate(time)"
                          >
                            <div class="cons">
                              <v-icon left>mdi-credit-card</v-icon>
                              {{ $t("pay_and_upgrade") }}
                              <help-info
                                :element-name="`${serviceName}-${componentName}-pay-update`"
                                :help-data="helpData"
                                :service-name="serviceName"
                                class="buttoninfo"
                                :label="$t('pay_and_upgrade')"
                              />
                            </div>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                  </v-expand-transition>
                  <v-expand-transition>
                    <div
                      v-if="!massUpdatePriceData?.total_count && !loading"
                      class="text-center"
                    >
                      <v-icon color="error" left>mdi-currency-usd</v-icon>
                      {{ $t("no_tariff_for_this_period") }}
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </custom-popup>

        <v-card-title class="grey--text justify-end">
          <div
            v-if="showCheck"
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-checkbox
              v-model="checkAll"
              class="mx-2 my-3"
              hide-details
              :label="$t('select_all')"
              off-icon="mdi-minus-box"
              @click="changeCheckBox"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-selectAll`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('filter')"
            />
          </div>

          <v-divider class="ma-2" vertical />

          <v-spacer class="d-md-none" />
          <div v-if="!showCheck" class="rowinfo comp">
            <header-status-filter
              v-model="statusFiltergroup"
              :count="count"
              :type="'group'"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-statusFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('filter')"
            />
          </div>
          <div
            v-else
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
          >
            <v-menu v-model="actionMenu" bottom nudge-bottom="5" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text v-bind="attrs" v-on="on">
                  {{ $t("actions") }}
                  <v-fade-transition mode="out-in">
                    <v-icon v-if="!actionMenu" key="down" class="ms-2"
                      >mdi-chevron-down
                    </v-icon>
                    <v-icon v-else key="up" class="ms-2">mdi-chevron-up</v-icon>
                  </v-fade-transition>
                </v-btn>
              </template>

              <v-list dense>
                <template v-for="(item, i) in itemsAction">
                  <v-list-item
                    v-if="item.condition"
                    :key="i"
                    color="primary"
                    @click="item.handler()"
                  >
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-menu>
            <help-info
              :element-name="`${serviceName}-${componentName}-actionMenu`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('filter')"
            />
          </div>
          <div
            class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center comp"
          >
            <header-type-filter
              v-model="typeFiltergroup"
              :count="count"
              :type="'group'"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-typeFilter`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('filter_type')"
            />
          </div>

          <slot name="content" />

          <v-spacer class="d-none d-md-flex" />

          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-text-field
                v-model="identifier"
                class="contentinfo"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('start_from')"
                outlined
                @keydown.enter="updateIdentifierFiltergroup(identifier)"
                @click:clear="updateIdentifierFiltergroup(null)"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loading && identifier && identifier.length >= 3"
                    color="primary"
                    indeterminate
                    size="20"
                    width="3"
                  />
                  <v-btn
                    v-else
                    class="mt-n1"
                    icon
                    small
                    @click="updateIdentifierFiltergroup(identifier)"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-identifier`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('search')"
              />
            </div>
          </v-card>

          <v-card class="ma-2" flat max-width="250" width="250">
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center comp"
            >
              <header-search-type-filter
                v-model="computedSearchgroup"
                :loading="loading"
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedSearch`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('search')"
              />
            </div>
          </v-card>

          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo comp mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <header-expire-type-filter v-model="expireTypeFiltergroup" />
              <help-info
                :element-name="`${serviceName}-${componentName}-expireTypeFilter`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('search')"
              />
            </div>
          </v-card>

          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-text-field
                v-model="idSearch"
                clear-icon="mdi-close-circle-outline"
                clearable
                dense
                hide-details
                :label="$t('search_in_id')"
                outlined
                @keydown.enter="updateIdSearchFiltergroup(idSearch)"
                @click:clear="updateIdSearchFiltergroup(null)"
              >
                <template v-slot:append>
                  <v-progress-circular
                    v-if="loading && idSearch"
                    color="primary"
                    indeterminate
                    size="20"
                    width="3"
                  />
                  <v-btn
                    v-else
                    class="mt-n1"
                    icon
                    small
                    @click="updateIdSearchFiltergroup(null)"
                  >
                    <v-icon>mdi-identifier</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
              <help-info
                :element-name="`${serviceName}-${componentName}-idSearch`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo const2"
                :label="$t('search_in_id')"
              />
            </div>
          </v-card>

          <v-card
            v-if="$route.name === 'qr.monitoring'"
            class="ma-2"
            flat
            max-width="250"
            width="250"
          >
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <users-picker
                v-model="computedUserFiltergroup"
                class="contentinfo"
                hide-details
              />
              <help-info
                :element-name="`${serviceName}-${componentName}-computedUserFilter`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo const2"
                :label="$t('filter_user')"
              />
            </div>
          </v-card>

          <v-card
            :disabled="(showCheck || count <= 0) && !hasErrorgroup"
            class="ma-2 pa-0 d-flex row rowinfo align-center"
            flat
            max-width="250"
          >
          </v-card>
        </v-card-title>
        .
        <v-card-title class="pt-0 d-flex ma-0 const6">
          <div
            class="d-flex row row mx-0 mt-0 pa-0 px-md-0 align-items-center justify-content-end const4"
            :style="
              !hasValidHelpinfo(`${serviceName}-${componentName}-resetStates`)
                ? 'margin-left: 20px !important'
                : 'margin-left: 0px !important'
            "
          >
            <v-btn
              :disabled="!hasFiltergroup"
              class="ma-0 btn-exit const6"
              depressed
              @click="removefilters"
            >
              {{ $t("clear_filters") }}
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-resetStates`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo const2"
              :label="$t('clear_filters')"
            />
          </div>
        </v-card-title>
        <slot class="const5" name="extension"></slot>

        <v-row class="const5">
          <div
            v-if="
              (hasFiltergroup && count > 0) ||
              (typeChoice && rowcount > 0) ||
              !typeChoice
            "
            class="rowinfo"
          >
          <v-btn
            class="ma-0 btn-edit contentinfo"
            depressed
            style="
              padding-left: 16px !important;
              justify-content: center;
              box-sizing: border-box;
            "
            @click="priceDial = true"
          >
            <v-icon left>mdi-timer-refresh-outline</v-icon>
            {{ $t("group_renewal") }}
          </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-priceDial`"
              :help-data="helpData"
              :service-name="serviceName"
              class="buttoninfo"
              :label="$t('group_renewal')"
            />
          </div>
        </v-row>

        <v-divider class="mx-3" />

        <custom-popup
          v-model="smsDialog"
          :cons="{ title: $t('send_sms') }"
          hide-confirm
          max-width="700"
        >
          <v-card class="p-8">
            <div
              v-if="description.desc && description.id"
              class="col-md-12 mx-auto p-3"
              style="
                background-color: rgb(212, 212, 212);
                color: black;
                font-weight: bold;
              "
            >
              <v-icon
                class="float-left"
                @click="
                  description.desc = '';
                  description.id = '';
                "
                >mdi-delete
              </v-icon>
              <p>{{ $t("selected_pattern") }}:</p>
              <p class="mt-1 pt-0" v-html="description.desc"></p>
            </div>

            <patterns-list v-model="description" />
            <div
              class="d-flex row rowinfo row mx-0 mt-2 pa-0 px-md-0 align-center"
            >
              <v-btn
                :disabled="!description.id"
                :loading="loading"
                class="mt-10 btn-send-sms contentinfo"
                outlined
                @click="sendPattern"
              >
                <v-icon left small>mdi-send</v-icon>
                {{ $t("send") }}
              </v-btn>
              <help-info
                :element-name="`${serviceName}-${componentName}-sendPattern`"
                :help-data="helpData"
                :service-name="serviceName"
                class="buttoninfo"
                :label="$t('send')"
              />
            </div>
          </v-card>
        </custom-popup>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import PatternsList from "../../robot/patternsList";
import { mapActions, mapGetters } from "vuex";
import HeaderTypeFilter from "./headerTypeFilter";
import HeaderStatusFilter from "./headerStatusFilter";
import UsersPicker from "../../../components/pickers/usersPicker";
import HeaderExpireTypeFilter from "./headerExpireTypeFilter";
import HeaderSearchTypeFilter from "./headerSearchTypeFilter";

export default {
  name: "listCardHeadergroup",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    HeaderSearchTypeFilter,
    HeaderExpireTypeFilter,
    UsersPicker,
    HeaderStatusFilter,
    HeaderTypeFilter,
    PatternsList,
  },

  props: {
    rowcount: { type: [Number, String], default: 0 },
    typeChoice: { type: Boolean, default: true },
    count: { type: [Number, String], default: 0 },
    value: Boolean,
    showCheck: Boolean,
    qrCard: [Object, Array],
    isLoading: Boolean,
    massUpdatePrice: Function,
    massUpdatePriceData: Object,
    massUpdate: Function,
    qrTypeCounts: Array,
  },

  data() {
    return {
      model: null,
      windowIndex: 0,
      showDetails: false,
      headersdetail: [
        { text: this.$t("row"), value: "index" },
        { text: this.$t("type"), value: "type" },
        { text: this.$t("count"), value: "number" },
      ],
      // qrTypeCounts: [],
      selectedTime: null,
      selectedItemsDetails: [],
      cardloading: false,
      priceloading: false,
      paymentloading: false,
      popupLoading: false,
      loading: false,
      loadinggroup: false,
      serviceName: "Qrland",
      componentName: "list-card-header",
      helpData: [],
      priceDial: false,
      drawer: false,
      actionMenu: false,
      search: "",
      identifier: "",
      idSearch: "",
      checkAll: false,
      smsDialog: false,
      bulkStatus: "",
      description: {},
      itemsAction: [
        {
          value: "pause",
          text: this.$t("deactivate"),
          handler: this.pauseAll,
          condition: true,
        },
        {
          value: "bulkDownload",
          text: this.$t("bulk_download"),
          handler: this.bulkDownload,
          condition: true,
        },
        {
          value: "sendSms",
          text: this.$t("send_sms"),
          handler: this.sendSms,
          condition: this.$route.name === "qr.monitoring",
        },
      ],
      renewalItems: [
        { value: 30, text: this.$t("one_month_renewal") },
        { value: 90, text: this.$t("three_month_renewal") },
        { value: 180, text: this.$t("six_month_renewal") },
        { value: 365, text: this.$t("one_year_renewal") },
      ],
      time: 0,
    };
  },

  mounted() {
    this.identifier = this.identifierFiltergroup;
    this.idSearch = this.idSearchFiltergroup;
  },

  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapGetters("localstorage", [
      "statusFiltergroup",
      "typeFiltergroup",
      "sortFiltergroup",
      "searchTypeFiltergroup",
      "hasFiltergroup",
      "identifierFiltergroup",
      "idSearchFiltergroup",
      "userFiltergroup",
      "expireTypeFiltergroup",
      "hasErrorgroup",
    ]),
    computedSortFiltergroup: {
      get() {
        return this.sortFiltergroup;
      },
      set(val) {
        this.updateSortFiltergroup(val);
      },
    },
    computedUserFiltergroup: {
      get() {
        return this.userFiltergroup;
      },
      set(val) {
        this.updateUserFiltergroup(val);
      },
    },
    computedSearchgroup: {
      get() {
        return this.searchTypeFiltergroup;
      },
      set(val) {
        this.updateSearchTypeFiltergroup(val);
      },
    },
  },

  watch: {
    value(val) {
      this.checkAll = val;
    },
    checkAll(val) {
      this.$emit("input", val);
    },
    identifierFiltergroup(val) {
      this.identifier = val;
    },
    idSearchFiltergroup(val) {
      this.idSearch = val;
    },
    qrCard(val) {
      let obj = val
        .map((item) => item.status)
        .reduce((acc, curr) => {
          acc[curr] = (acc[curr] || 0) + 1;
          return acc;
        }, {});

      let status = "";
      let count = Infinity;
      for (const key in obj) {
        if (obj[key] < count) {
          count = obj[key];
          status = key;
        }
      }

      this.bulkStatus =
        Object.keys(obj).length >= 2
          ? status
          : status === "active"
          ? "deactivate"
          : "active";
      let f = {
        active: this.$t("activate"),
        deactivate: this.$t("deactivate"),
      };
      this.$nextTick(() => {
        this.itemsAction.find((item) => item.value === "pause").text =
          f[this.bulkStatus];
      });
    },
    "massUpdatePriceData.close"(val) {
      this.$nextTick(() => {
        this.priceDial = false;
      });
    },
    priceDial(val) {
      if (val) {
        this.popupLoading = true;
        this.$nextTick(() => {
          this.popupLoading = false;
        });
      }
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "updateSortFiltergroup",
      "updateSearchTypeFiltergroup",
      "updateIdentifierFiltergroup",
      "updateIdSearchFiltergroup",
      "updateUserFiltergroup",
      "resetStatesGroup",
      "updatePerPageFiltergroup",
      "updatePageFiltergroup",
    ]),
    async showCardDetails(time) {
      this.selectedTime = time; // ذخیره زمان انتخاب‌شده
      this.cardloading = true;
      try {
        // فیلتر کردن فقط آیتم‌های انتخاب شده از listDetail
        const selectedItems =
          this.qrCard?.filter((item) => item.checkbox) || [];

        if (selectedItems.length === 0) {
          this.$toast.warning(this.$t("no_item_selected"));
          return;
        }

        // محاسبه تعداد و نوع آیتم‌های انتخاب شده
        const typeCounts = {};
        selectedItems.forEach((item) => {
          const type = item.type || "unknown";
          typeCounts[type] = (typeCounts[type] || 0) + 1;
        });

        // تبدیل به فرمت مورد نیاز برای نمایش
        this.selectedItemsDetails = Object.keys(typeCounts).map((type) => ({
          type: type,
          count: typeCounts[type],
          name: this.getQrTypes(type)?.name || type,
        }));

        await this.massUpdatePrice(time); // فراخوانی متد برای دریافت اطلاعات
        this.showDetails = true; // نمایش جزئیات
      } catch (error) {
        this.$toast.error(this.$t("error_loading_card_info"));
        this.cardloading = false;
      } finally {
        this.cardloading = false;
      }
    },
    removefilters() {
      this.resetStatesGroup();
      this.$nextTick(() => {
        this.$emit("resetFilters");
      });
    },
    changeCheckBox() {
      this.$nextTick(() => {
        this.$emit("check", this.checkAll);
      });
    },
    hasValidHelpinfo(elementName) {
      if (
        (!this.helpData ||
          !Array.isArray(this.helpData) ||
          this.helpData.length === 0) &&
        !this.ribbon_can("guideuser")
      ) {
        return false;
      }
      const itemElement = this.helpData?.find(
        (p) =>
          p.name &&
          typeof p.name === "string" &&
          p.name.trim() === (elementName?.trim() || "")
      );
      return itemElement || this.ribbon_can("guideuser");
    },
    pauseAll() {
      this.$emit("pause-sel", this.bulkStatus);
    },
    bulkDownload() {
      this.loading = true;

      let qrs =
        this.qrCard?.map((item) => {
          return {
            image: item.image,
            title: item.title.replace(/\s+/g, "_"),
          };
        }) || [];

      const counts = {};
      const result = qrs.map((item) => {
        if (item.title in counts) {
          counts[item.title]++;
          item.title = `${item.title}(${counts[item.title] - 1})`;
        } else {
          counts[item.title] = 1;
        }
        return item;
      });

      let link =
        this.$route.name === "qr.monitoring"
          ? "/admin/download"
          : "/v1/testQr/download-qrs";
      this.$api
        .post(link, {
          qrs: result,
        })
        .then(({ data }) => {
          if (data) {
            if (data.status) {
              this.$toast.success(data.message);

              let a = document.createElement("a");
              a.setAttribute("href", `${this.$qrUrl}/qr/zip/${data.data}`);
              a.setAttribute("target", "_blank");
              a.download = data.data;
              a.click();
            } else {
              this.$toast.error(data.message);
            }
          }
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("error_occurred"));
        })
        .finally(() => (this.loading = false));
    },
    sendSms() {
      this.smsDialog = true;
    },
    sendPattern() {
      this.loading = true;

      let patternCount = 0;
      try {
        const regex = new RegExp(/data\d+/, "gd");
        patternCount = this.description.content.match(regex).length;
      } catch (e) {}

      this.$api
        .post("/admin/qr/sms", {
          qr_ids: this.qrCard.map((item) => item.id),
          pattern_id: this.description.id,
          length: patternCount,
        })
        .then(({ data }) => {
          this.$toast.success(this.$t("send_registered_successfully"));
          this.smsDialog = false;
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("error_occurred"));
        })
        .finally(() => (this.loading = false));
    },
    async getPrice(time) {
      this.priceloading = true;
      try {
        this.time = time;
        await this.massUpdatePrice(time);
      } catch (error) {
        this.$toast.error(this.$t("error_getting_prices"));
        this.time = 0; // Reset time on error
      } finally {
        this.priceloading = false;
      }
    },
    async handleMassUpdate(time) {
      this.paymentloading = true;
      try {
        await this.massUpdate(time);
      } catch (error) {
        this.$toast.error(this.$t("payment_error"));
      } finally {
        this.paymentloading = false;
      }
    },
    getQrTypes(type) {
      const qrTypes = [
        {
          value: "visitcard",
          name: this.$t("business_card"),
          icon: "card-account-details",
        },
        { value: "productlabel", name: this.$t("product_label"), icon: "tag" },
        {
          value: "businesscard",
          name: this.$t("business_card"),
          icon: "briefcase",
        },
        {
          value: "restaurantmenu",
          name: this.$t("restaurant_menu"),
          icon: "food",
        },
        { value: "eventticket", name: this.$t("event_ticket"), icon: "ticket" },
        { value: "brochure", name: this.$t("brochure"), icon: "file-document" },
        { value: "flyer", name: this.$t("flyer"), icon: "file-image" },
        { value: "poster", name: this.$t("poster"), icon: "image" },
        { value: "catalog", name: this.$t("catalog"), icon: "book-open" },
        { value: "newsletter", name: this.$t("newsletter"), icon: "newspaper" },
      ];
      return qrTypes.find((t) => t.value === type);
    },
  },
};
</script>

<style scoped>
.v-input--checkbox >>> .v-label {
  margin: 0 4px;
}

.comp {
  flex-wrap: nowrap !important;
  display: flex;
  flex-direction: row;
}
/* استایل برای کارت‌ها */
.v-card {
  transition: transform 0.3s ease;
}

.vtest:hover {
  transform: scale(1.05);
}

.v-btn.nav-btn {
  background-color: #ca3102ff;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  min-width: 40px;
}

.v-window {
  overflow: hidden;
  border-radius: 8px;
}

.v-window-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.const2 {
  align-content: center !important;
  align-self: center !important;
}
.const3 {
  padding-left: 16px !important;
  justify-content: center;
  box-sizing: border;
}
.const6 {
  justify-content: end !important;
}
.const4 {
  min-width: min-content;
  max-width: fit-content;
  margin-bottom: unset;
}
.const5 {
  width: 100%;
  justify-content: center !important;
  margin: 0px !important;
}
</style>
